module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    ref: "usuario",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.commit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('nome')
    }
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome Completo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.name),
      expression: "dados.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nome')),
      expression: "errors.has('nome')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("nome")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.email),
      expression: "dados.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("email")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true
    }
  }, [_c('label', {
    attrs: {
      "for": "telefone"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##)#####-####', '(##)####-####']),
      expression: "['(##)#####-####', '(##)####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.telefone),
      expression: "dados.telefone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "telefone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "telefone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('nivel')
    }
  }, [_c('label', {
    attrs: {
      "for": "nivel"
    }
  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nivel),
      expression: "dados.nivel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nivel",
      "type": "text",
      "disabled": _vm.atualizacao
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "nivel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "administrador"
    }
  }, [_vm._v("Administrador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "regulador"
    }
  }, [_vm._v("Regulador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "marcador"
    }
  }, [_vm._v("Marcador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "prestador"
    }
  }, [_vm._v("Prestador")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nivel')),
      expression: "errors.has('nivel')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("nivel")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('usuario')
    }
  }, [_c('label', {
    attrs: {
      "for": "usuario"
    }
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.login),
      expression: "dados.login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "usuario",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "login", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('usuario')),
      expression: "errors.has('usuario')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("usuario")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('senha')
    }
  }, [_c('label', {
    attrs: {
      "for": "senha"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.password),
      expression: "dados.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.atualizacao
      }),
      expression: "{ required: !atualizacao }"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.dados.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('senha')),
      expression: "errors.has('senha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("senha")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('confirmacaoSenha')
    }
  }, [_c('label', {
    attrs: {
      "for": "confirmacaoSenha"
    }
  }, [_vm._v("Redigite a Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmacaoSenha),
      expression: "confirmacaoSenha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.atualizacao,
        is: _vm.dados.password
      }),
      expression: "{ required: !atualizacao, is: dados.password }"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "name": "confirmacaoSenha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmacaoSenha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmacaoSenha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmacaoSenha')),
      expression: "errors.has('confirmacaoSenha')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("confirmacaoSenha")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidades Vinculadas")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "select-dias",
      "placeholder": "Clique para selecionar a(s) unidade(s)...",
      "multiple": "",
      "options": _vm.selectUnidades
    },
    model: {
      value: (_vm.dados.unidades),
      callback: function($$v) {
        _vm.$set(_vm.dados, "unidades", $$v)
      },
      expression: "dados.unidades"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "anotacoes"
    }
  }, [_vm._v("Anotações")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.anotacoes),
      expression: "dados.anotacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "anotacoes",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.dados.anotacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "anotacoes", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("CONTRATOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "contrato.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "contrato.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "contrato.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "contrato.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "contrato.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "contrato.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("AGENDA")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "agenda.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "agenda.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "agenda.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "agenda.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "agenda.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "agenda.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELATÓRIO DE SOLICITAÇÕES")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.solicitacao"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.solicitacao") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.solicitacao",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELATÓRIO DE ESCALAS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.escalas"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.escalas") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.escalas",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELATÓRIO DE OFERTAS DE PROCEDIMENTO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.ofertas"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.ofertas") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.ofertas",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELAÇÃO DE USUÁRIOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.usuarios"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.usuarios") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.usuarios",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("RELATÓRIO AGENDA DO PRESTADOR")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "relatorio.agenda.prestador"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "relatorio.agenda.prestador") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "relatorio.agenda.prestador",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("DISTRIBUIR")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("CONTROLE DE CONTRATOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.contrato.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.contrato.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.contrato.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.contrato.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.contrato.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.contrato.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("CONTROLE DA AGENDA")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.agenda.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.agenda.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.agenda.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "distribuicao.agenda.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "distribuicao.agenda.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "distribuicao.agenda.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("SOLICITAR")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("VERIFICAR SOLITAÇÃO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("CANCELAR SOLICITAÇÃO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.cancelar"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.cancelar") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.cancelar",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("REGULAR SOLICITAÇÃO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.regular"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.regular") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.regular",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("ATENDIDO/FALTA")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitacao.atendidoFalta"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "solicitacao.atendidoFalta") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitacao.atendidoFalta",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(8), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("PACIENTES")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "paciente.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "paciente.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "paciente.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "paciente.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "paciente.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "paciente.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("PROFISSIONAIS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "profissional.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "profissional.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "profissional.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "profissional.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "profissional.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "profissional.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("UNIDADES")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "unidade.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "unidade.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "unidade.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "unidade.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "unidade.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "unidade.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("GRUPOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "grupo.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "grupo.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "grupo.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "grupo.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "grupo.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "grupo.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("SUBGRUPOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "subgrupo.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "subgrupo.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "subgrupo.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "subgrupo.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "subgrupo.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "subgrupo.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("FORMAS DE ORGANIZAÇÃO")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "forma.organizacao.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "forma.organizacao.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "forma.organizacao.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "forma.organizacao.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "forma.organizacao.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "forma.organizacao.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("PROCEDIMENTOS")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "procedimento.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "procedimento.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "procedimento.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "procedimento.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "procedimento.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "procedimento.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-solid collapsed-box",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v("PACIENTES")]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "paciente-integracao.read"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "paciente-integracao.read") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "paciente-integracao.read",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "container-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.permissoes),
      expression: "dados.permissoes"
    }],
    attrs: {
      "type": "checkbox",
      "value": "paciente-integracao.write"
    },
    domProps: {
      "checked": Array.isArray(_vm.dados.permissoes) ? _vm._i(_vm.dados.permissoes, "paciente-integracao.write") > -1 : (_vm.dados.permissoes)
    },
    on: {
      "click": function () {},
      "change": function($event) {
        var $$a = _vm.dados.permissoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "paciente-integracao.write",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dados, "permissoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dados, "permissoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dados, "permissoes", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "a",
      "to": "/cadastros/usuarios"
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "text-transform": "none !important"
    },
    attrs: {
      "type": "submit",
      "value": "Salvar",
      "disabled": _vm.finalizado
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Permissões do Usuário")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Administração")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atualizar Dados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Distribuição")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_vm._v("\n                                                    -\n                                                    "), _c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atualizar Dados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Atendimentos")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "90%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cadastros")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atualizar Dados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Integração com o sistema Antigo")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("Funcionalidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atualizar Dados")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-a26ebf02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastros/usuarios/Form.vue
// module id = 889
// module chunks = 0